<template>
  <div v-if="showLegend" class="bubbles-legends-accordion-container accordion" role="tablist">
    <b-card no-body>
      <b-card-header header-tag="header" class="p-1" role="tab">
        <div class="title-toggle" @click="isExpanded = !isExpanded">
          <span class="mr-2">{{ legendTitle }}</span>
          <span class="ml-2">
            <b-icon
              v-if="isExpanded"
              icon="caret-down-fill"
              :class="{
                'when-opened': legendPosition !== TOP_LEFT,
                'when-closed': legendPosition === TOP_LEFT,
              }"
            />
            <b-icon
              v-else
              icon="caret-up-fill"
              :class="{
                'when-closed': legendPosition !== TOP_LEFT,
                'when-opened': legendPosition === TOP_LEFT,
              }"
            />
          </span>
        </div>
      </b-card-header>
      <b-collapse
        id="bubbles-legends-accordion"
        v-model="isExpanded"
        appear
        visible
        accordion="accordion-bubbles-legends"
        role="tabpanel"
      >
        <b-card-body :class="{ 'bg-logo': legendPosition === BOTTOM_RIGHT }">
          <BubblesLegends />
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import BubblesLegends from '@/components/public/BubblesLegends.vue'
import { LegendPositions } from '@/types'

const components = {
  BubblesLegends,
}

@Component({ components })
export default class BubblesLegendsAccordion extends Vue {
  BOTTOM_RIGHT = LegendPositions.BOTTOM_RIGHT
  TOP_LEFT = LegendPositions.TOP_LEFT
  isExpanded = true

  created() {
    this.isExpanded = !this.isMobile && !this.xyBubblesVisualisationActive
  }

  get isMobile() {
    return this.$typedStore.public.display.isMobile
  }

  get legendConfig() {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.bubblesLegends
  }

  get legendPosition() {
    return this.legendConfig.legendPosition
  }

  get showLegend() {
    return (
      this.legendConfig.showLegend &&
      (this.bubblesVisualisationActive || this.xyBubblesVisualisationActive)
    )
  }

  get legendTitle() {
    return this.legendConfig.legendTitle
  }

  get xyBubblesVisualisationActive() {
    return this.$typedStore.activeVisualisation.isXYBubbles
  }

  get bubblesVisualisationActive() {
    return this.$typedStore.activeVisualisation.isBubbles
  }
}
</script>

<style lang="scss" scoped>
.title-toggle {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 16px;
  padding: 0.25em 1.25em;
  color: #455;

  cursor: pointer;
}
.bg-logo a.orbviz-logo-link {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 0 calc(0.8rem - 0.5rem - 1px) calc(0.8rem - 0.5rem - 1px) 0;
  opacity: 0.85;
}

.bg-logo.card-body {
  padding-bottom: calc(1.25rem + 0.5rem);
}
.card {
  border-radius: var(--border-radius);
  .card-header {
    background: none;
    border-bottom: none;
  }
  .card-body {
    padding: 0 1.25rem 0.5rem 1.25rem;
  }
}
</style>
